export default "__VITE_ASSET__BfLL6N7p__"